import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css/autoplay';
import "swiper/css";
const Section8 = () => {
  return (
    <>
      <section className="instagram ">
        <div className="container">
          <div className="instagram_header">
            <h2 className="instagram_header-title">Follow Us on Instagram</h2>
            <p className="instagram_header-text">
              Accumsan sit amet nulla facilisi morbi tempus. Suscipit tellus
              mauris a diam maecenas sed enim ut sem
            </p>
          </div>
        </div>
        <Swiper
          slidesPerView={4}
          autoplay={{ delay: 3000 }}
        >
          <SwiperSlide>
            <div className="instagram_slider-slide swiper-slide">
              <a
                className="link"
                href="/"
                target="_blank"
                rel="noopener norefferer"
              >
                <img
                  className="lazy"
                  src="https://similux-vinovatheme.myshopify.com/cdn/shop/files/img-3-12_991fd43f-82a8-4186-8138-da3e9ee58779_600x600_crop_center.jpg?v=1679129935"
                  alt="instagram post"
                />
                <span className="overlay d-flex justify-content-center align-items-center">
                  <i className="icon-instagram" />
                </span>
              </a>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="instagram_slider-slide swiper-slide">
              <a
                className="link"
                href="/"
                target="_blank"
                rel="noopener norefferer"
              >
                <img
                  className="lazy"
                  src="https://similux-vinovatheme.myshopify.com/cdn/shop/files/img-3-11_c0dde73e-13ba-4b6c-a09f-a6c8abda35db_600x600_crop_center.jpg?v=1679129934"
                  alt="instagram post"
                />
                <span className="overlay d-flex justify-content-center align-items-center">
                  <i className="icon-instagram" />
                </span>
              </a>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="instagram_slider-slide swiper-slide">
              <a
                className="link"
                href="/"
                target="_blank"
                rel="noopener norefferer"
              >
                <img
                  className="lazy"
                  src="https://similux-vinovatheme.myshopify.com/cdn/shop/files/img-3-9_6bd827fe-b98c-4b6c-bc13-092ebdd3ea16_600x600_crop_center.jpg?v=1679129934"
                  alt="instagram post"
                />
                <span className="overlay d-flex justify-content-center align-items-center">
                  <i className="icon-instagram" />
                </span>
              </a>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="instagram_slider-slide swiper-slide">
              <a
                className="link"
                href="/"
                target="_blank"
                rel="noopener norefferer"
              >
                <img
                  className="lazy"
                  src="https://similux-vinovatheme.myshopify.com/cdn/shop/files/img-3-10_7df44eab-aa24-4754-9a1f-9f0d263849dc_600x600_crop_center.jpg?v=1679129935"
                  alt="instagram post"
                />
                <span className="overlay d-flex justify-content-center align-items-center">
                  <i className="icon-instagram" />
                </span>
              </a>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="instagram_slider-slide swiper-slide">
              <a
                className="link"
                href="/"
                target="_blank"
                rel="noopener norefferer"
              >
                <img
                  className="lazy"
                  src="https://similux-vinovatheme.myshopify.com/cdn/shop/files/img-3-9_6bd827fe-b98c-4b6c-bc13-092ebdd3ea16_600x600_crop_center.jpg?v=1679129934"
                  alt="instagram post"
                />
                <span className="overlay d-flex justify-content-center align-items-center">
                  <i className="icon-instagram" />
                </span>
              </a>
            </div>
          </SwiperSlide>
        </Swiper>
        {/* <div className="instagram_slider swiper">
          <div className="swiper-wrapper"></div>
        </div> */}
      </section>
    </>
  );
};

export default Section8;
